import *as _ from 'lodash'
import {ModelTermBO} from "./ModelTermBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ModelBO} from "./ModelBO";
import {
    WB_ModelCannibalizationRelationshipRow,
    WB_ModelPredictorRelationshipRow, WB_ModelPredictorRow, WB_ModelRow, WB_ModelTermRelationshipRow,
    WB_ModelVolumeComponentItemRow,
    WB_ModelVolumeComponentRelationshipRow,
    WB_PowerMetricRelationshipRow,
    WB_PowerMetricRow
} from "../PA.Core/PAdbSchemaRows";
import {esWB_AffinityGroup, esWB_Power_Metric_Relationship} from "../PA.Core/PAdbSchema";
import {CustomerBO} from "../PA.MD.BusinessObjects/CustomerBO";
import {PASearch} from "../PA.Core/PASearch";

export class ModelBOValidations {

    static Validation(aBO: ModelBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            ModelBOValidations.ValidateEmptyFields(aBO)
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return ModelBOValidations.ValidateResidualMethod(aBO)
                })
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return ModelBOValidations.ValidateCannibalization(aBO)
                })
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return ModelBOValidations.ValidateModelFormula(aBO)
                })
                .then(() => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    return ModelBOValidations.ValidatePredictorMetaMappings(aBO)
                })
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve()
                        return
                    }

                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    static ValidateEmptyFields(aBO: ModelBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            if (_.isEmpty(aBO.WB_Model.cif.MODEL_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'modelid',
                        title: "Model ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('modelid')
            }
            if (_.isEmpty(aBO.WB_Model.cif.MODEL_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'modelname',
                        title: "Model Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('modelName')
            }

            if (_.isEmpty(aBO.WB_Model.cif.MODEL_TYPE)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'modeltype',
                        title: "Model Type cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('modeltype')
            }

            //Validate the Cann Type - Power Metrics - Predictors to the Core Volume Formula
            async function validatePowerMetric() {

                let arrCoreVolumePredictors = _.keyBy(_.filter(
                    aBO.WB_Model.WB_ModelPredictorRelationshipRows,
                    (aPredRelRow: WB_ModelPredictorRelationshipRow) =>
                        aPredRelRow.isActive
                ), 'WB_MODEL_PREDICTOR_ID')

                let invalidPowerMetrics: string[] = []

                for (let aRow of aBO.WB_Model.WB_ModelCannibalizationRelationshipRows) {
                    if (aRow.isActive) {
                        let powerMetricRow: WB_PowerMetricRow = aRow.WB_PowerMetricRow
                        if (!_.isUndefined(powerMetricRow)) {
                            let powerMetricRels: WB_PowerMetricRelationshipRow[] = await aBO.dbContext.findAll(esWB_Power_Metric_Relationship, {
                                where: {
                                    WB_MODEL_POWERMETRIC_ID: powerMetricRow.cif.WB_MODEL_POWERMETRIC_ID,
                                    DELETED_IND: {nin: ["1"]}
                                }
                            })
                            _.forEach(powerMetricRels, (aPowerMetricRel: WB_PowerMetricRelationshipRow) => {
                                if (aPowerMetricRel.isActive) {
                                    if (!(aPowerMetricRel.cif.WB_MODEL_PREDICTOR_ID in arrCoreVolumePredictors)
                                        && (invalidPowerMetrics.indexOf(powerMetricRow.cif.POWERMETRIC_NAME) == -1)
                                    ) {
                                        invalidPowerMetrics.push(powerMetricRow.cif.POWERMETRIC_NAME)
                                    }
                                }
                            })
                        }
                    }
                }

                if (invalidPowerMetrics.length > 0) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'modelPredictor',
                            title: "Power Metric " + _.toString(invalidPowerMetrics) + " contains predictors that do not exist in the core volume formula. Please select a power metric that has the valid predictors. ",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                }
            }

            validatePowerMetric()

            let uniqCoeffIds = _.uniqBy(aBO?.WB_Model.WB_ModelCannibalizationRelationshipRows, (canRelType: WB_ModelCannibalizationRelationshipRow) => {
                return canRelType.cif.WB_MODEL_COEFFICIENT_ID
            })

            if (aBO?.WB_Model?.WB_ModelCannibalizationRelationshipRows.length != uniqCoeffIds.length) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'duplicateCannTypes',
                        title: "Save failed. Please ensure the same cannibalization coefficient is not used for multiple cannibalization types.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            }

            resolve()

        })

    }

    static ValidateResidualMethod(aBO: ModelBO): Promise<void> {

        return new Promise<void>((resolve, error) => {

            let residualMethod = aBO.WB_Model.cif.RESIDUAL_METHOD
            let sameOrder = false
            let sameValue = false
            let nonObservedValue: { flag: boolean, name: string[] } = {flag: false, name: []}
            let lastValue: number
            let decompositionOrderSet = new Set()
            if (residualMethod === 'residual') {
                const activeRelationshipRows = _.filter(aBO.WB_Model.WB_ModelVolumeComponentRelationshipRows, (x) => x.isActive)

                _.forEach(activeRelationshipRows, (row: WB_ModelVolumeComponentRelationshipRow, idx) => {
                    // if ((row.cif.DECOMPOSITION_ORDER) === lastValue) {
                    //     sameValue = true
                    // }

                    lastValue = _.toNumber(row.cif.DECOMPOSITION_ORDER)
                    decompositionOrderSet.add(lastValue)

                    // For the last volume component BEFORE the 'Residual Volume', all predictors must be set to 'Observed'
                    if (idx === activeRelationshipRows.length - 2) {
                        _.forEach(row.WB_ModelVolumeComponentItemRows, (itemRow: WB_ModelVolumeComponentItemRow) => {
                            let componentName = itemRow.WB_ModelVolumeComponentRelationshipRow.WB_ModelVolumeComponentRow.cif.VOLUME_COMPONENT_NAME
                            if (!nonObservedValue.flag && itemRow.cif.VALUE_TYPE !== 'self') {
                                nonObservedValue.flag = true
                                nonObservedValue.name.push(componentName)
                            }
                        })
                    }

                })
                if (activeRelationshipRows.length !== decompositionOrderSet.size) {
                    sameValue = true
                }
                if (nonObservedValue.flag) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'modelPredictor',
                            title: `All 'Parameter Values' should be set to 'Observed Value' for ${nonObservedValue.name.join(',')}`,
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('modelPredictor');
                }
                // if (sameOrder) {
                //     aBO.ValidateMessageProvider.addMessage(
                //         {
                //             type: MessageType.Error,
                //             code: 'sameOrder',
                //             title: `Current decomposition order is not allowed. Please enter distinct order sequence on the “Volume Decomposition” tab.`,
                //             description: "",
                //             subtitle: "",
                //             count: 0
                //         })
                // }
                // else {
                //     aBO.ValidateMessageProvider.removeMessage('sameOrder');
                // }
                if (sameValue) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'sameValue',
                            title: `Duplicate values in 'Decompositon Order' Column is not allowed`,
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('sameValue');
                }
            }
            resolve()
        })


    }

    static ValidateCannibalization(aBO: ModelBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let modelRow: WB_ModelRow = aBO.WB_Model

            let bCann: boolean = (modelRow.cif.CANNIBALIZATION_IND == '1') ? true : false
            if (bCann) {
                let arrCannTypeRel: WB_ModelCannibalizationRelationshipRow[] =
                    _.filter(modelRow.WB_ModelCannibalizationRelationshipRows,
                        (aCannRelRow: WB_ModelCannibalizationRelationshipRow) => aCannRelRow.isActive)
                if (arrCannTypeRel.length == 0) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'modelCannRel',
                            title: `Missing cannibalization type under the cannibalization tab`,
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                }

                _.forEach(arrCannTypeRel, (aRelRow: WB_ModelCannibalizationRelationshipRow) => {
                    let powerMetric = aRelRow.cif.WB_MODEL_POWERMETRIC_ID
                    if(powerMetric == 0 || _.isUndefined(powerMetric)) {
                        aBO.ValidateMessageProvider.addMessage(
                            {
                                type: MessageType.Error,
                                code: 'modelCannRelPowerMetric',
                                title: `Missing Power Metric for ` + aRelRow.WB_ModelCannibalizationTypeRow.cif.CANNIBALIZATION_TYPE_NAME,
                                description: "",
                                subtitle: "",
                                count: 0
                            })
                    }

                    let modelFunction = aRelRow.cif.WB_MODEL_FUNCTION_ID
                    if(modelFunction == 0 || _.isUndefined(modelFunction)) {
                        aBO.ValidateMessageProvider.addMessage(
                            {
                                type: MessageType.Error,
                                code: 'modelCannRelModelfunc',
                                title: `Missing Model Function for ` + aRelRow.WB_ModelCannibalizationTypeRow.cif.CANNIBALIZATION_TYPE_NAME,
                                description: "",
                                subtitle: "",
                                count: 0
                            })
                    }
                })
            }
            resolve()
        })
    }

    static ValidateModelFormula(aBO: ModelBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let modelRow: WB_ModelRow = aBO.WB_Model
            let modelTerms = _.map(_.filter(modelRow.WB_ModelTermRelationshipRows, (aMTRow: WB_ModelTermRelationshipRow) => aMTRow.isActive), (aModelTerm: WB_ModelTermRelationshipRow) =>
                aModelTerm.WB_ModelTermRow.cif.TERM_ID
            )
            let modelPredictorFormula = modelRow.cif.MODEL_FORMULA

            //remove all spaces
            modelPredictorFormula = modelPredictorFormula.replace(/\s/g, '')

            //replace all math operators with "#"
            modelPredictorFormula = modelPredictorFormula.replace(/[()+\-*/.]/g, '#')

            let arrPredictorsFromFormula = modelPredictorFormula.split("#")
            let keyPredictorFormulaTerms = _.keyBy(arrPredictorsFromFormula, (a) => a)

            for(let aTerm of modelTerms) {
                if(!(aTerm in keyPredictorFormulaTerms))
                {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'modelPredictorFormulaError',
                            title: 'Model Term '+aTerm+' has been assigned to the model, but is not used in the Predictive Model Formula.  Please remove the term, or update the formula, as appropriate.',
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                }
            }

            resolve()
        })
    }

    static ValidatePredictorMetaMappings(aBO: ModelBO) : Promise<void> {
        return new Promise<void>((resolve) => {

            let predictors: WB_ModelPredictorRow[] = _.flatMap(_.filter(aBO.drWB_Model.WB_ModelPredictorRelationshipRows, (aRow) => aRow.cif.DELETED_IND != "1"), (aRow) => aRow.WB_ModelPredictorRow)
            //only allow one predictor to be mapped to any one predictor meta per model
            let metaIdToPredictor = _.groupBy(predictors, (aPredictor: WB_ModelPredictorRow) => aPredictor.cif.PREDICTOR_META_ID)
            _.forEach(metaIdToPredictor, (predictors: WB_ModelPredictorRow[], metaId : string) => {
                if (predictors.length > 1) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'modelPredictorMetaTypeError',
                            title: `Predictors ${_.join(_.map(predictors, x => x.cif.MODEL_PREDICTOR_ID), ", ")} are mapped to meta type ${metaId}. Please confirm only one predictor is mapped to a meta type per model`,
                            description: "",
                            subtitle: "",
                            count: 0
                        }
                    )
                }
            })
            resolve()
        })
    }
}
